<template>
  <div class="div-footer">
    <v-footer dark class="secondary elevation-12" app inset>
      <v-row justify="center" no-gutters>
        <div>PayX &copy; {{ new Date().getFullYear() }}</div>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "div-footer"
};
</script>

<style scoped>
.footer {
  bottom: 0;
}
</style>
